export default {
  done: { id: 'done' },
  completed: { id: 'completed' },
  inProgress: { id: 'in_progress' },
  eventsComplete: { id: 'events_complete' },
  eventsInProgress: { id: 'events_in_progress' },
  eventsDone: { id: 'events_done' },
  dailyLogbookEvents: { id: 'daily_logbook_events' },
  result: { id: 'result' },
  addComment: { id: 'add_comment' },
  save: { id: 'save' },
  of: { id: 'of' },
}
